import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./auth/authConfig";
import "./index.css";
import App from "./App";

const initializeApp = async () => {
  const msalInstance = new PublicClientApplication(msalConfig);

  // Initialize MSAL
  await msalInstance.initialize();

  // Listen for sign-in event and set active account
  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      (event.payload as AuthenticationResult)?.account
    ) {
      const account = (event.payload as AuthenticationResult).account;
      msalInstance.setActiveAccount(account);
    }
  });

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App instance={msalInstance} />
    </React.StrictMode>
  );
};

initializeApp().catch(console.error);
